<template>
    <div id="payment-form">
        <div id="payment-element"></div>
        <div v-if="showaddressDiv" class="row addressDiv gt-stripe-group">
            <div class="col-12">
                <div class="form-group mt-form">
                    <label>Address</label>
                    <input type="text"
                           v-model="this.customer_details.address.line1"
                           class="form-control max-100"
                           name="address"
                           placeholder="123 Address st"
                           autocomplete="on"
                           ref="origin" />
                    <ErrorMessage name="address" class="text-danger" />
                </div>
            </div>
        </div>
        <div v-if="showaddressDiv" class="row addressDiv no-gutters gutter-8 overRideP gt-stripe-group">
            <div class="col-6 pl-0">
                <div class="form-group mt-form">
                    <label>City</label>
                    <input v-model="this.customer_details.address.city "
                           type="text"
                           class="form-control max-100 locality"
                           name="city"
                           placeholder="City" />
                    <ErrorMessage name="city" class="text-danger" />
                </div>
            </div>
            <div class="col-6 pr-0">
                <div class="form-group mt-form">
                    <label>State</label>
                    <input v-model="this.customer_details.address.state"
                           type="text"
                           class="form-control max-100 administrative_area_level_1"
                           placeholder="State"
                           name="state" />
                    <ErrorMessage name="state" class="text-danger" />
                </div>
            </div>

        </div>

        <button id="contribution-button" class="mt-4 max-100" @click="submit">
            <svg xmlns="http://www.w3.org/2000/svg"
                 fill="none"
                 viewBox="0 0 14 16"
                 width="14"
                 height="16">
                <path fill="white"
                      d="M 7 0 C 4.8 0 3 1.8 3 4 V 5 H 1 C 0.4 5 0 5.4 0 6 V 15 C 0 15.6 0.4 16 1 16 H 13 C 13.6 16 14 15.6 14 15 V 6 C 14 5.4 13.6 5 13 5 H 11 V 4 C 11 1.8 9.2 0 7 0 Z M 8 11.7 V 13 H 6 V 11.7 C 5.4 11.4 5 10.7 5 10 C 5 8.9 5.9 8 7 8 C 8.1 8 9 8.9 9 10 C 9 10.7 8.6 11.4 8 11.7 Z M 9 5 H 5 V 4 C 5 2.9 5.9 2 7 2 C 8.1 2 9 2.9 9 4 V 5 Z"></path>
            </svg>
            <div class="spinner hidden" id="spinner"></div>
            <span id="button-text" class="mt-pay-btn payment-block">Pay ${{this.amount}} now</span>
        </button>
        <label id="payment-message" style="color:red"></label>
        <p class="mt-tagline pb-4 mb-0 payment-block">
            By continuing you agree to GroupTogether’s
            <a href="https://grouptogether.com/us/terms" target="_blank" rel="noopener">Terms</a> &
            <a href="https://grouptogether.com/us/privacy" target="_blank" rel="noopener">Privacy Policy</a>
        </p>
    </div>
</template>
<script>
    /* eslint-disable */
    import { loadStripe } from '@stripe/stripe-js/pure';

    let stripe = '';
    let elements = undefined; 

    export default {
        name: 'StripePayment',
        components: {},
        props: ['amount', "customer_details", "collection_id", "message", "service_fee", "collection_guid"],
        data() {
            return {
                showaddressDiv: false,
                clientS: '',
                stripekey: ""
            }
        },
        async mounted() {
            await this.getKey();
            await this.initialize();
           /* this.geolocation();*/
            await this.CheckDoubleEntry();
        },
        methods: {
            async getKey() {
                this.$emit('showLoadScreen');
                await fetch('/api/gifts/getkey')
                    .then((res) => res.json())
                    .then((data) => {
                        this.$emit('hideLoadScreen');
                        this.stripekey = data.Message;
                    })
                    .catch(err => console.log(err.message))
            },
            timeout(ms) {
                    return new Promise(resolve => setTimeout(resolve, ms));
            },
           async CheckDoubleEntry() {
                var colId = this.collection_id;
               var email = this.customer_details.email;
               let check = false;
               await $.ajax({
                    type: "GET",
                    url: "/account/IsDoubleEntry",
                    data: { email: email , collectionId: colId },
                    success: function (result) {
                        if (result == "1") {
                            check = true;
                        }
                        else if (result == "quickSuccession") {
                            check = false;
                        }
                        else {
                            check = false;
                        }                    
                    }
               });
               this.mtDoubleCheck = check;
                    },
            async initialize() {
                stripe = await loadStripe(this.stripekey);
                const amountAsCents = this.amount * 100;
                const response = await fetch("/api/payments/create-payment-intent", {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ fname: this.customer_details.firstName, lname: this.customer_details.lastName, email: this.customer_details.email, amountAsCents: amountAsCents, collectionId: this.collection_id, contributionamount: this.amount, message: this.message, servicefee: this.service_fee }),
                }).catch((err) => {
                    console.log(JSON.stringify(err))
                    alert("Something went wrong - reloading the page")
                    window.location.reload();
                });

                const { ClientSecret } = await response.json();
                this.clientS = ClientSecret;
                const appearance = {
                    theme: 'stripe'
                };
                elements = stripe.elements({ appearance, clientSecret: ClientSecret });
                const paymentElement = elements.create("payment");
                paymentElement.mount("#payment-element");
                this.showaddressDiv = true;
            },
            async submit(e) {
                $("#payment-message").html('');
                var Url = '';
                var check = this.mtDoubleCheck;
                    e.preventDefault();
                    this.setLoading(true);
                if (this.service_fee) {
                    const { error } = await stripe.confirmPayment({
                        elements,
                        confirmParams: {
                            payment_method_data: {
                                billing_details: {
                                    name: `${this.customer_details.firstName} ${this.customer_details.lastName}`,
                                    email: this.customer_details.email,
                                    address: {
                                        line1: `${this.customer_details.address.line1}`,
                                        city: `${this.customer_details.address.city}`,
                                        state: `${this.customer_details.address.state}`,
                                    }
                                }
                            },
                        },
                        redirect: 'if_required'
                    });
                    //fetch result in client side
                    this.retrievePaymentStatus(this.clientS);

                }
                else {
                    if (check) {
                        this.$emit('DoubleEntryContribution');
                        this.mtDoubleCheck = false;
                    }
                    else {
                        Url = `${window.top.location.origin}/payment-confirmed`;
                        const { error } = await stripe.confirmPayment({
                            elements,
                            confirmParams: {
                                return_url: Url,
                                payment_method_data: {
                                    billing_details: {
                                        name: `${this.customer_details.firstName} ${this.customer_details.lastName}`,
                                        email: this.customer_details.email,
                                        address: {
                                            line1: `${this.customer_details.address.line1}`,
                                            city: `${this.customer_details.address.city}`,
                                            state: `${this.customer_details.address.state}`,
                                        }
                                    }
                                },
                            },
                        });

                        if (error.type === "card_error" || error.type === "validation_error") {
                            $("#payment-message").append(error.message);
                            console.log(error.message);
                            this.$emit('hideLoadScreen');
                        } else {
                            console.log("An unexpected error occured.");
                            this.$emit('hideLoadScreen');
                        }
                    }
                }
                    this.setLoading(false);
                    this.$emit('hideLoadScreen');
                
                  
                
            },
            async retrievePaymentStatus(cs) {
                 await stripe.retrievePaymentIntent(cs).then(({ paymentIntent }) => {
                    switch (paymentIntent.status) {
                        case "succeeded":
                            this.$emit('spendcollection');
                           break;
                        case "processing":
                            alert("Your payment is processing.");
                             break;
                        case "requires_payment_method":
                           
                            break;
                        default:
                            alert("Something went wrong.");
                            break;
                    }
                });
            },
            setLoading(isLoading) {
                if (isLoading) {
                    // Disable the button and show a spinner
                    document.querySelector("#contribution-button").disabled = true;
                    document.querySelector("#spinner").classList.remove("hidden");
                    document.querySelector("#button-text").classList.add("hidden");
                } else {
                    document.querySelector("#contribution-button").disabled = false;
                    document.querySelector("#spinner").classList.add("hidden");
                    document.querySelector("#button-text").classList.remove("hidden");
                }
            },
            geolocation() {
                if (this.mode != "Preview" || this.mode != "Share") {
                    for (let ref in this.$refs) {
                        const autocomplete = new google.maps.places.Autocomplete(this.$refs[ref]);
                        autocomplete.addListener("place_changed", () => {
                            let postcode = "";
                            let address1 = "";
                            let state = "";
                            let city = "";
                            const place = autocomplete.getPlace();
                            this.customer_details.address.line1 = place.name;


                            for (const component of place.address_components) {
                                const componentType = component.types[0];
                                switch (componentType) {


                                    //case "route": {
                                    //    address1 += " " + component.short_name;
                                    //    break;
                                    //}
                                    case "postal_code": {
                                        postcode = `${component.long_name}${postcode}`;
                                        break;
                                    }
                                    case "administrative_area_level_1": {
                                        state = component.short_name;
                                        break;
                                    }
                                    case "administrative_area_level_2": {
                                        city = component.short_name;
                                        break;
                                    }
                                    //case "locality": {
                                    //    address1 += " " + component.short_name;
                                    //    break;
                                    //}
                                    //case "colloquial_area": {
                                    //    address1 += " " + component.short_name;
                                    //    break;
                                    //}
                                    //case "political": {
                                    //    address1 += " " + component.short_name;
                                    //    break;
                                    //}
                                    //case "premise": {
                                    //    address1 += " " + component.short_name;
                                    //    break;
                                    //}
                                }
                                this.customer_details.address.postal_code = postcode
                                //this.customer_details.address.line1 = address1
                                this.customer_details.address.city = city
                                this.customer_details.address.state = state
                            }
                        });

                    }
                }
            },
        },
    };
</script>
<style>
    #payment-element.Input {
        height: 56px !important;
    }
</style>